<template>
  <div>
    <div class="projects-list">
      <div
        style="cursor: pointer"
        class="element-box form-control text-center p-1 mb-4"
      >
        <h6 class="text-dark" style="color: #0019f3">
          Listado de Devoluciones a Proveedores
        </h6>
      </div>
      <div
        class="project-box"
        v-for="current in dataTabla.results"
        v-bind:key="current.id"
        @click="rowClick(current)"
      >
        <div style="cursor: pointer; background-color: #ebffdb">
          <div class="project-head">
            <div class="project-title">
              <h5># {{ current.numero }} - {{ current.tienda }}</h5>
              {{ current.tienda.nombre }}
              <p>
                <small>{{ current.fecha }}</small> <br />
                <small>{{ current.observacion }}</small>
              </p>
            </div>
          </div>
          <div class="project-info">
            <div class="row align-items-center">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="el-tablo highlight text-center">
                      <div class="label">Estatus</div>
                      <div>
                        <h6
                          class="font-weight-bold"
                          v-bind:style="
                            current.estado == 'A'
                              ? 'color: #258E04;'
                              : 'color: #8E0404;'
                          "
                        >
                          {{ current.estado_str }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  props: {
    dataTabla: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {
    ...mapGetters({}),
  },
  mounted() {},
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "wms-devolucion-provedor-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "wms-devolucion-provedor-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("devolucionproveedores/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
  },
};
</script>
